import Vue from 'vue'
import App from './App.vue'
import loadGoogleMapsApi from './loadGoogleMapsApi';

Vue.prototype.$loadGoogleMapsApi = loadGoogleMapsApi(
  'AIzaSyA2KjJU3bYjUCGH30Q4XcMmBIabVcsSeBM'
);
Vue.config.productionTip = false
Vue.component('App', App)

new Vue({
}).$mount('#app')